import React from 'react';
import { Button } from './Button';
import { degerFarkindaListe } from '../../utils/selectOptions';

/**
 * PaginationControls — sayfalama kontrolünün TEK görünümü (rota 2.5).
 *
 * Kontrollü bileşen: durumu taşımaz. İstemci tarafı listeler `usePagination`
 * çıktısını, sunucu taraflı listeler (müşteri) kendi sayfa/toplam değerlerini verir.
 *
 * Sol grup (Sayfada: [n] kayıt · Toplam N) yalnız `limit` + `onLimit` verilmişse;
 * sağ grup (← Önceki  x / y  Sonraki →) yalnız birden fazla sayfa varsa basılır.
 * Mevcut limit seçeneklerde yoksa listeye eklenir — açılır liste kayıttaki değeri
 * gizleyemez (rota 2.9 kuralı; katalog 15 ile açılıp "10" gösteriyordu).
 */

interface PaginationControlsProps {
  sayfa: number;
  toplamSayfa: number;
  onSayfa: (n: number) => void;
  limit?: number;
  limitSecenekleri?: number[];
  onLimit?: (n: number) => void;
  toplam?: number;
  className?: string;
}

const VARSAYILAN_LIMIT_SECENEKLERI = [10, 25, 50, 100];

export const PaginationControls: React.FC<PaginationControlsProps> = ({
  sayfa,
  toplamSayfa,
  onSayfa,
  limit,
  limitSecenekleri = VARSAYILAN_LIMIT_SECENEKLERI,
  onLimit,
  toplam,
  className = '',
}) => {
  const limitVar = limit !== undefined && onLimit !== undefined;
  const gezinmeVar = toplamSayfa > 1;
  if (!limitVar && !gezinmeVar) return null;

  const secenekler = limitVar
    ? degerFarkindaListe(limitSecenekleri.map(String), String(limit))
    : [];

  return (
    <div className={`flex flex-col sm:flex-row justify-between items-center gap-4 py-3 px-1 ${className}`}>
      {limitVar ? (
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <span>Sayfada:</span>
          <select
            aria-label="Sayfa başına kayıt"
            value={String(limit)}
            onChange={(e) => onLimit(Number(e.target.value))}
            className="border border-gray-300 rounded px-2 py-1 bg-white font-medium focus:outline-none focus:border-secondary"
          >
            {secenekler.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
          <span>kayıt</span>
          {toplam !== undefined && <span className="text-gray-400">· Toplam {toplam}</span>}
        </div>
      ) : (
        <span />
      )}

      {gezinmeVar && (
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" disabled={sayfa <= 1} onClick={() => onSayfa(sayfa - 1)}>
            ← Önceki
          </Button>
          <span className="text-sm font-medium font-mono text-gray-700 px-2">
            {sayfa} / {toplamSayfa}
          </span>
          <Button variant="ghost" size="sm" disabled={sayfa >= toplamSayfa} onClick={() => onSayfa(sayfa + 1)}>
            Sonraki →
          </Button>
        </div>
      )}
    </div>
  );
};
